import { Module } from 'vuex';

import { RecentLessonInfoState, RootState } from 'frontend/types';

export interface RecentLessonInfo {
  recommended: RecentLessonInfoState[];
}

const recentLessonInfo: Module<RecentLessonInfo, RootState> = {
  namespaced: true,
  state: {
    recommended: [],
  } as RecentLessonInfo,
  getters: {
    recentLessonList: (state: RecentLessonInfo): RecentLessonInfoState[] => {
      return state.recommended;
    },
  },
  mutations: {
    setValue(state: RecentLessonInfo, value: RecentLessonInfoState[]): void {
      state.recommended = value;
    },
  },
  actions: {},
};

export default recentLessonInfo;
